import orderService from "../../services/ordersService";
import requestsService from "@/services/requestsService";

const state = {
    orders: [],
    current_order: {},
    current_comments: null,
    old_format: false,
    current_requests: [],
    current_page: 1,
    open_orders_current_page: 1,
    current_page_size: 50,
    open_orders_current_page_size: 50,
    total_results: 0,
    filter: {},
    open_orders_filter: {'status__in': 'Submitted,FOCDateApproved,Rejected,PendingCancellation'},
    search: '',
    open_orders_search: '',
    notification: {},
    show_notification: false,
    show_current_order: false,
    executing_add: false,
    executing_update: {status: false, type: 'all'},
    executing_request_add: false,
    executing_comment_add: false
};

const getters = {
    orders: state => state.orders,
    old_format: state => state.old_format,
    total_results: state => state.total_results,
    current_order: state => state.current_order,
    current_requests: state => state.current_requests,
    current_comments: state => state.current_comments,
    current_page: state => state.current_page,
    open_orders_current_page: state => state.open_orders_current_page,
    current_page_size: state => state.current_page_size,
    open_orders_current_page_size: state => state.open_orders_current_page_size,
    filter: state => state.filter,
    open_orders_filter: state => state.open_orders_filter,
    search: state => state.search,
    open_orders_search: state => state.open_orders_search,
    notification: state => state.notification,
    show_notification: state => state.show_notification,
    show_current_order: state => state.show_current_order,
    executing_add: state => state.executing_add,
    executing_request_add: state => state.executing_request_add,
    executing_comment_add: state => state.executing_comment_add,
    executing_update: state => state.executing_update
};

const actions = {
    getOrders({commit}, payload) {
        orderService.fetchOrders(payload)
            .then(results => {
                commit('setOrders', results)
            })
            .catch(error => {
                console.log(error)
                commit('setNotification', {text: 'Failed to get orders!', type: 'error'})
            })
    },
    getOrder({commit}, id) {
        orderService.fetchOrder(id)
            .then(result => {
                commit('setSelectedOrder', result)
            })
            .catch(error => {
                console.log(error)
                commit('setCurrentOrder', {})
                commit('setNotification', {text: 'Failed to get order!', type: 'error'})
            })
    },
    addOrder({commit}, payload) {
        commit('setExecutingAdd', true)
        orderService.postOrder(payload)
            .then(order => {
                commit('addOrder', order)
                commit('setNotification', {text: 'Order successfully added', type: 'success'})
                commit('setShowNotification', true)
            })
            .catch(error => {
                console.log(error)
                commit('setExecutingAdd', false)
                commit('setNotification', {text: 'Failed to create order!', type: 'error'})
                commit('setShowNotification', true)
            })
    },
    patchOrder({commit}, payload) {
        let id = payload['id']
        delete payload['id']
        let type = payload['type']
        delete payload['type']
        commit('setExecutingUpdate', {status: true, type: 'all'})
        orderService.patchOrder(id, payload)
            .then(order => {
                order.type = type
                commit('updateOrder', order)
                commit('setNotification', {text: 'Order successfully updated', type: 'success'})
                commit('setShowNotification', true)
            })
            .catch(error => {
                console.log(error)
                commit('updateOrder', null)
                commit('setNotification', {text: 'Failed to update order!', type: 'error'})
                commit('setShowNotification', true)
            })
    },
    getRequests({commit}, payload) {
        requestsService.fetchRequests(payload)
            .then(results => {
                commit('setCurrentRequests', results['results'])
            })
            .catch(error => {
                console.log(error)
                commit('setCurrentRequests', {})
                commit('setNotification', {text: 'Failed to fetch Porting Order Request!', type: 'error'})
            })
    },
    addRequest({commit}, payload) {
        commit('setExecutingRequestAdd', true)
        requestsService.postRequest(payload)
            .then(order => {
                //commit('addRequest', order)
                console.log(order)
                commit('setExecutingRequestAdd', false)
                commit('setNotification', {text: 'Request successfully added', type: 'success'})
                commit('setShowNotification', true)
            })
            .catch(error => {
                console.log(error)
                commit('setExecutingRequestAdd', false)
                commit('setNotification', {text: 'Failed to create request!', type: 'error'})
                commit('setShowNotification', true)
            })
    },
    getComments({commit}, payload) {
        requestsService.fetchComments(payload)
            .then(results => {
                // new requests format with comments
                if (results['results'].length > 0) {
                    commit('setCurrentComments', results['results'])
                    commit('setOldFormat', false)
                }
                else {
                    requestsService.fetchRequests({porting_order_id: payload.porting_order})
                        .then(results => {
                            results = results['results'].map(function (res) {
                                return {'request': res}
                            })
                            commit('setOldFormat', true)
                            commit('setCurrentComments', results)
                        })
                        .catch(error => {
                            console.log(error)
                            commit('setCurrentComments', null)
                            commit('setNotification', {text: 'Failed to fetch Porting Order Request!', type: 'error'})
                        })
                }
            })
            .catch(error => {
                console.log(error)
                commit('setCurrentComments', null)
                commit('setNotification', {text: 'Failed to fetch Porting Order Comments!', type: 'error'})
            })
    },
    addComment({commit}, payload) {
        commit('setExecutingCommentAdd', true)
        requestsService.postComment(payload)
            .then(comment => {
                commit('addComment', comment)
                commit('setExecutingCommentAdd', false)
                commit('setNotification', {text: 'Comment successfully added', type: 'success'})
                commit('setShowNotification', true)
            })
            .catch(error => {
                console.log(error)
                commit('setExecutingCommentAdd', false)
                commit('setNotification', {text: 'Failed to add comment!', type: 'error'})
                commit('setShowNotification', true)
            })
    },
    setShowNotification({commit}, value) {
        commit('setShowNotification', value)
    },
    setShowCurrentOrder({commit}, value) {
        commit('setShowCurrentOrder', value)
    },
    setCurrentPage({commit}, value) {
        commit('setCurrentPage', value)
    },
    setOpenOrdersCurrentPage({commit}, value) {
        commit('setOpenOrdersCurrentPage', value)
    },
    setFilter({commit}, value) {
        commit('setFilter', value)
        commit('setCurrentPage', 1)
    },
    setOpenOrdersFilter({commit}, value) {
        commit('setOpenOrdersFilter', value)
        commit('setOpenOrdersCurrentPage', 1)
    },
    setOpenOrdersSearch({commit}, value) {
        commit('setOpenOrdersSearch', value)
        commit('setOpenOrdersCurrentPage', 1)
    },
    setSearch({commit}, value) {
        commit('setSearch', value)
        commit('setCurrentPage', 1)
    },
    setOpenOrdersCurrentOrder({commit}, value) {
        commit('setOpenOrdersCurrentOrder', value)
        commit('setShowCurrentOrder', true)
    },
    setCurrentOrder({commit}, value) {
        commit('setCurrentOrder', value)
        commit('setShowCurrentOrder', true)
    },
    setOpenOrdersCurrentPageSize({commit}, value) {
        commit('setOpenOrdersCurrentPageSize', value)
    },
    setCurrentPageSize({commit}, value) {
        commit('setCurrentPageSize', value)
    },
    setCurrentRequests({commit}, value) {
        commit('setCurrentRequests', value)
    },
    setCurrentComments({commit}, value) {
        commit('setCurrentComments', value)
    },
};

const mutations = {
    setOrders(state, results) {
        state.orders = results['results']
        state.total_results = results['count']
    },
    setCurrentOrder(state, order) {
        state.current_order = order
    },
    setCurrentComments(state, comments) {
        state.current_comments = comments
    },
    setOldFormat(state, format) {
        state.old_format = format
    },
    setFilter(state, filter) {
        state.filter = filter
    },
    setOpenOrdersFilter(state, filter) {
        state.open_orders_filter = filter
    },
    setSearch(state, search) {
        state.search = search
    },
    setOpenOrdersSearch(state, search) {
        state.open_orders_search = search
    },
    addOrder(state) {
        /*if (!state.search && Object.keys(state.filter).length === 0) {
            state.orders.unshift(order.porting_order)
        }*/
        state.executing_add = false
    },
    addRequest(state) {
        /*let index = state.orders.findIndex(item => item.id === result.porting_order_id.id);
        if (index !== -1) state.orders.splice(index, 1, result.porting_order_id);*/

        state.executing_request_add = false;
    },
    updateOrder(state, result) {
        /*if (result) {
            let status_filter = (result.type === "open") ? state.open_orders_filter : state.filter;
            delete result['type'];
            if (status_filter && status_filter['status__in']) status_filter = status_filter['status__in'].split(',');
            if (status_filter['status__in'] && status_filter.includes(result.status)) {
                let item = state.orders.find(item => item.id === result.id);
                Object.assign(item, result);
            } else {
                let index = state.orders.findIndex(item => item.id === result.id);
                if (index !== -1) state.orders.splice(index, 1);
            }
        }*/
        state.executing_update = {status: false, type: result.type}
    },
    setCurrentRequests(state, requests) {
        state.current_requests = requests
    },
    setNotification(state, value) {
        state.notification = value
    },
    setShowNotification(state, value) {
        state.show_notification = value
    },
    setShowCurrentOrder(state, value) {
        state.show_current_order = value
    },
    setCurrentPage(state, value) {
        state.current_page = value
    },
    setOpenOrdersCurrentPage(state, value) {
        state.open_orders_current_page = value
    },
    setCurrentPageSize(state, value) {
        state.current_page_size = value
    },
    setOpenOrdersCurrentPageSize(state, value) {
        state.open_orders_current_page_size = value
    },
    setExecutingAdd(state, value) {
        state.executing_add = value
    },
    setExecutingRequestAdd(state, value) {
        state.executing_request_add = value
    },
    setExecutingCommentAdd(state, value) {
        state.executing_comment_add = value
    },
    setExecutingUpdate(state, value) {
        state.executing_update = value
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}